import { createSlice } from "@reduxjs/toolkit";
import {
  GetAnnouncementAction,
  GetAnnouncementUserList,
  SendAnnouncementAction,
} from "store/middlewares/announcement";

export const announcementSlice = createSlice({
  name: "announcement",
  initialState: {
    announcementLoading: true,
    announcement: null,
    sendAnnouncementLoading: false,
    userList: null,
    userListLoading: false,
  },
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(GetAnnouncementAction.pending, (state) => {
        state.announcement =
          state.announcement?.data?.length > 0 ? state.announcement : null;
      })
      .addCase(GetAnnouncementAction.fulfilled, (state, action) => {
        state.announcementLoading = false;
        state.announcement = action.payload.response;
      })
      .addCase(GetAnnouncementAction.rejected, (state) => {
        state.announcementLoading = false;
        state.announcement = null;
      })
      .addCase(SendAnnouncementAction.pending, (state) => {
        state.sendAnnouncementLoading = true;
      })
      .addCase(SendAnnouncementAction.fulfilled, (state) => {
        state.sendAnnouncementLoading = false;
      })
      .addCase(SendAnnouncementAction.rejected, (state) => {
        state.sendAnnouncementLoading = false;
      })

      .addCase(GetAnnouncementUserList.pending, (state) => {
        state.userList =
          state.userList?.data?.length > 0 ? state.userList : null;
      })
      .addCase(GetAnnouncementUserList.fulfilled, (state, action) => {
        state.userListLoading = false;
        state.userList = action.payload.response;
      })
      .addCase(GetAnnouncementUserList.rejected, (state) => {
        state.userListLoading = false;
        state.userList = null;
      });
  },
});

export default announcementSlice.reducer;
